module.exports = __webpack_public_path__ + "img/des_paint_4.475ae39c.jpg";